export default {

  getSurveyList() {
    return this.http('ExerciseCheck', 'get', 'api/v2/survey');

  },

  postSurveyAnswer(params) {
    return this.http('ExerciseCheck', 'post', 'api/v2/survey', params);

  },

  getEvaluations() {
    return this.http('SEAFARER', 'get', '/api/v1/evaluations');

  },

  getSurveyHistory(params) {
    return this.http(
      'SEAFARER',
      'get',
      '/api/v1/evaluation_history',
      params
    );
  }
};
